import React from "react";
import type { MenuRulePermissionCanFn } from "@Front/Utils/filterMenuItemsByCan";
import { IItem } from "./MenuItem";
import { MenuChrome } from "./MenuChrome";
import { useMenuController } from "./useMenuController";

type IProps = {
	children: React.ReactNode;
	items: IItem[];
	openingSide?: "left" | "right" | "center";
	openOnHover?: boolean;
	/** Filtrage matrice avec un `can` dédié (ex. office sélecteur vs contexte dossier invité). */
	matrixCan?: MenuRulePermissionCanFn;
};

export default function Menu(props: IProps): React.JSX.Element | null {
	const { openingSide = "left", items, children, openOnHover, matrixCan } = props;
	const c = useMenuController({ items, openingSide, openOnHover, matrixCan });
	if (c.hide) {
		return null;
	}
	return (
		<MenuChrome
			openingSide={c.openingSide}
			openOnHover={c.openOnHover}
			toggle={c.toggle}
			handleMouseEnter={c.handleMouseEnter}
			handleMouseLeave={c.handleMouseLeave}
			iconRef={c.iconRef}
			subMenuRef={c.subMenuRef}
			shouldShowSubMenu={c.shouldShowSubMenu}
			items={c.effectiveItems}
			isSuperAdmin={c.isSuperAdmin}
			close={c.close}>
			{children}
		</MenuChrome>
	);
}
